import moment from "moment";

const formatDatabaseDateOnly = (date) => {
    if (!date) {
        return null;
    }

    return moment(date).format("DD/MM/YYYY");
};

export default formatDatabaseDateOnly;